import type { Theme } from '@mui/material/styles';

export type ResponsiveBreakpoint = 'mobile' | 'tablet' | 'desktop';

export const SPACING = {
  MOBILE_HEADER_HEIGHT: 60,
  TABLET_HEADER_HEIGHT: 80,
  DESKTOP_HEADER_HEIGHT: 100,
  SEARCH_MARGIN_BOTTOM: 16,
  GRID_MARGIN_MOBILE: 0,
  GRID_MARGIN_TABLET: 8,
  GRID_MARGIN_DESKTOP: 16,
  HEADER_TOP_MARGIN: 20,
  SECTION_PADDING: 24,
  MOBILE_TOP_OFFSET: 16,
  MOBILE_BOTTOM_OFFSET: 16,
  MOBILE_HEADER_SECTION: 48,
  MOBILE_SEARCH_HEIGHT: 40
} as const;

export const getDataGridStyles = (
  _breakpoint: ResponsiveBreakpoint,
  _theme: Theme
) => {
  return {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  };
};

export const getDataGridProps = (breakpoint: ResponsiveBreakpoint) => {
  const isMobile = breakpoint === 'mobile';
  const isTablet = breakpoint === 'tablet';

  return {
    rowHeight: isMobile ? 92 : isTablet ? 60 : 52,
    pageSizeOptions: isMobile ? [5, 10, 20] : [10, 20, 50, 100],
    disableColumnMenu: isMobile,
    disableColumnResize: isMobile,
    columnHeaderHeight: isMobile ? 40 : isTablet ? 48 : 56
  };
};

export const getSlotProps = (breakpoint: ResponsiveBreakpoint) => {
  const isMobile = breakpoint === 'mobile';
  const isTablet = breakpoint === 'tablet';

  return {
    toolbar: {
      showQuickFilter: !isMobile && !isTablet,
      quickFilterProps: {
        debounceMs: 500,
        placeholder: 'Search...'
      },
      sx: isMobile
        ? {
            padding: '4px 8px',
            '& .MuiDataGrid-toolbarContainer': {
              padding: '4px'
            }
          }
        : isTablet
          ? {
              padding: '6px 12px',
              '& .MuiDataGrid-toolbarContainer': {
                padding: '6px'
              }
            }
          : {}
    },
    pagination: {
      labelRowsPerPage: 'Work orders per page:',
      labelDisplayedRows: ({
        from,
        to,
        count
      }: {
        from: number;
        to: number;
        count: number;
      }) =>
        `${from}-${to} of ${count !== -1 ? count : `more than ${to}`} work orders`
    }
  };
};

export const getSearchFieldStyles = () => {
  return {
    px: 1,
    py: 0.5,
    mb: 1,
    mt: 0
  };
};

export const getSearchInputProps = () => ({
  sx: {
    fontSize: '0.875rem',
    '& input': {
      padding: '8px 4px'
    }
  }
});

export const getHeaderStyles = (_breakpoint: ResponsiveBreakpoint) => {
  return {
    mt: 0,
    pb: 0
  };
};
